export const LocalStorageConstants = {
    USER_INFO: "userInfo",
    OKTA_TOKEN: "okta-token-storage"
};
